import { MenuItem, Select } from "@mui/material";
import { useState } from "react";
import CustomSelectIcon from "./CustomSelectIcon";

const CustomSelect = ({ options, value, selectValue }: CustomSelectProps) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Select
      displayEmpty
      value={value}
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      onChange={(event) => {
        setOpen(false);
        selectValue(event.target.value);
      }}
      IconComponent={() => <CustomSelectIcon handleOpen={handleOpen} />}
      sx={{
        "fieldset:hover": {
          borderColor: "#000000",
        },
      }}
      className={`custom-select ${open ? "Mui-focused" : ""}`}
    >
      <MenuItem disabled value="">
        -
      </MenuItem>

      {options.map((option, index) => (
        <MenuItem key={index} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default CustomSelect;

export interface CustomSelectProps {
  options: CustomSelectOption[];
  value: number | "";
  selectValue(optionID: string | number | null): void;
}

export interface CustomSelectOption {
  label: string;
  value: string | number;
}
